import React, { Component } from "react";
import { Toast } from "antd-mobile";
import { selectTruckBrokerContract } from "../../../services/author";
import { getPathParams } from "../../../utils/utils";
import {getPreviewHost} from '../../../utils/siteTools';
import styles from './agreementDetail.less';

export default class AgreementDetail extends Component {
  state = {
    useFileUrl: ""
  };
  componentWillUnmount(){
    // sessionStorage.removeItem('actionVisible')
  }
  componentDidMount() {
    const obj = getPathParams(this.props.location.search);
    selectTruckBrokerContract({
      contractTemplateCode: obj.contractTemplateCode || ""
    }).then(data => {
      if (data.code === 0) {
        this.setState({
          useFileUrl: data.data.useFileUrl || ""
        });
      } else {
        Toast.fail(data.msg);
        this.props.history.goBack();
      }
    });
  }

  handleLeftClick = () => {
    this.props.history.goBack()
  }
  render() {
    const clientHeight = document.body.clientHeight - 45;
    const { useFileUrl } = this.state;
    return (
      <div>
        <div className={styles.bgView}>
          {useFileUrl ? (
            <iframe
              className={styles.embedStyle}
              title="合同详情"
              ref={embed => {
                this.embed = embed;
              }}
              style={{ height: clientHeight }}
              src = {`${getPreviewHost()}/onlineviewServer/onlinePreview?url=${encodeURI(useFileUrl)}`}
            />
          ) : (
            <div className={styles.loading}>
              loading...
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/author/contract/agreementDetail.js